const PENDING_KEY = 'landscope_pending_downloads';
export const pendingDownloadsStorage = {
    read() {
        try {
            const raw = localStorage.getItem(PENDING_KEY);
            if (!raw)
                return [];
            const arr = JSON.parse(raw);
            return Array.isArray(arr) ? arr : [];
        }
        catch (_a) {
            return [];
        }
    },
    write(list) {
        try {
            localStorage.setItem(PENDING_KEY, JSON.stringify(list));
        }
        catch (_a) { }
    },
    add(item) {
        const list = this.read();
        if (!list.some(x => x.downloadId === item.downloadId)) {
            list.push(item);
            this.write(list);
        }
    },
    remove(downloadId) {
        const list = this.read().filter(x => x.downloadId !== downloadId);
        this.write(list);
    },
    update(downloadId, updates) {
        const list = this.read();
        const idx = list.findIndex(x => x.downloadId === downloadId);
        if (idx >= 0) {
            list[idx] = { ...list[idx], ...updates };
            this.write(list);
        }
    },
    findByDownloadId(downloadId) {
        return this.read().find(x => x.downloadId === downloadId);
    },
    findReadyByProjectId(projectId) {
        const now = Date.now();
        const list = this.read();
        const hit = list.find(x => x.projectId === projectId &&
            x.status === 'ready' &&
            x.url &&
            (!x.expiresAt || now <= x.expiresAt));
        if (hit && hit.url) {
            return { downloadId: hit.downloadId, url: hit.url, expiresAt: hit.expiresAt };
        }
        return null;
    }
};
